import {css} from '@emotion/css';
import {Breakpoints, mq, negative} from '../../../styles/js/mixins';
import {columnHalf, columnStackableMobile, containerStackMobile} from '../../../styles/js/mixins/layout';
import {colours, spacing} from '../../../styles/js/variables';

const styles = {
  homepagePartners: css`
    label: homepagePartners;
    ${containerStackMobile}
    color: ${colours.font.BLACK};

    ${mq(Breakpoints.TABLET)} {
      align-items: center;
    }
  `,
  content: css`
    label: homepagePartners__content;
    ${columnStackableMobile()}

    ${mq(Breakpoints.TABLET)} {
      ${columnHalf}
      padding-right: ${spacing.L};
    }
  `,
  sectionTitle: css`
    label: homepagePartners__sectionTitle;
    margin-bottom: ${spacing.XS};
  `,
  supportingInfo: css`
    label: homepagePartners__supportingInfo;
    position: relative;
    align-self: center;

    ${mq(Breakpoints.TABLET)} {
      ${columnHalf}
      align-self: flex-start;
      margin-left: auto;
    }
  `,
  image: css`
    label: homepagePartners__image;
    display: block;
    width: 100%;
    margin: ${negative(spacing.XXS)};
  `,
};

export default styles;
